export const POST_SALE_PRODUCT_TO_FISCAL_REQUEST = "POST_SALE_PRODUCT_TO_FISCAL_REQUEST"
export const POST_SALE_PRODUCT_TO_FISCAL_SUCCESS = "POST_SALE_PRODUCT_TO_FISCAL_SUCCESS"
export const POST_SALE_PRODUCT_TO_FISCAL_FAIL = "POST_SALE_PRODUCT_TO_FISCAL_FAIL"


export const POST_SALE_FBR_PRODUCT_REQUEST = "POST_SALE_FBR_PRODUCT_REQUEST"
export const POST_SALE_FBR_PRODUCT_SUCCESS = "POST_SALE_FBR_PRODUCT_SUCCESS"
export const POST_SALE_FBR_PRODUCT_FAIL = "POST_SALE_FBR_PRODUCT_FAIL"

export const POST_SALE_PRODUCT_REQUEST = "POST_SALE_PRODUCT_REQUEST"
export const POST_SALE_PRODUCT_SUCCESS = "POST_SALE_PRODUCT_SUCCESS"
export const POST_SALE_PRODUCT_FAIL = "POST_SALE_PRODUCT_FAIL"

export const GET_SALE_PRODUCT_REQUEST = "GET_SALE_PRODUCT_REQUEST"
export const GET_SALE_PRODUCT_SUCCESS = "GET_SALE_PRODUCT_SUCCESS"
export const GET_SALE_PRODUCT_FAIL = "GET_SALE_PRODUCT_FAIL"

export const GET_SALE_CONSOLIDATED_FOR_SHOPS_REQUEST = "GET_SALE_CONSOLIDATED_FOR_SHOPS_REQUEST"
export const GET_SALE_CONSOLIDATED_FOR_SHOPS_SUCCESS = "GET_SALE_CONSOLIDATED_FOR_SHOPS_SUCCESS"
export const GET_SALE_CONSOLIDATED_FOR_SHOPS_FAIL = "GET_SALE_CONSOLIDATED_FOR_SHOPS_FAIL"

export const GET_SALE_CONSOLIDATED_FOR_SHOPS_ON_DATE_REQUEST = "GET_SALE_CONSOLIDATED_FOR_SHOPS_ON_DATE_REQUEST"
export const GET_SALE_CONSOLIDATED_FOR_SHOPS_ON_DATE_SUCCESS = "GET_SALE_CONSOLIDATED_FOR_SHOPS_ON_DATE_SUCCESS"
export const GET_SALE_CONSOLIDATED_FOR_SHOPS_ON_DATE_FAIL = "GET_SALE_CONSOLIDATED_FOR_SHOPS_ON_DATE_FAIL"

export const GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_REQUEST = "GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_REQUEST"
export const GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_SUCCESS = "GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_SUCCESS"
export const GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_FAIL = "GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_FAIL"

export const GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_REQUEST = "GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_REQUEST"
export const GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_SUCCESS = "GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_SUCCESS"
export const GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_FAIL = "GET_SALE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_FAIL"


export const GET_SALE_CONSOLIDATED_PROFIT_FOR_SHOPS_REQUEST = "GET_SALE_PROFIT_CONSOLIDATED_FOR_SHOPS_REQUEST"
export const GET_SALE_CONSOLIDATED_PROFIT_FOR_SHOPS_SUCCESS = "GET_SALE_PROFIT_CONSOLIDATED_FOR_SHOPS_SUCCESS"
export const GET_SALE_CONSOLIDATED_PROFIT_FOR_SHOPS_FAIL = "GET_SALE_PROFIT_CONSOLIDATED_FOR_SHOPS_FAIL"

export const GET_SALE_ON_INVOICE_NO_REQUEST = "GET_SALE_ON_INVOICE_NO_REQUEST";
export const GET_SALE_ON_INVOICE_NO_SUCCESS = "GET_SALE_ON_INVOICE_NO_SUCCESS";
export const GET_SALE_ON_INVOICE_NO_FAIL = "GET_SALE_ON_INVOICE_NO_FAIL";

export const GET_SALE_CREDIT_SINGLE_RECORD_REQUEST = "GET_SALE_CREDIT_SINGLE_RECORD_REQUEST";
export const GET_SALE_CREDIT_SINGLE_RECORD_SUCCESS = "GET_SALE_CREDIT_SINGLE_RECORD_SUCCESS";
export const GET_SALE_CREDIT_SINGLE_RECORD_FAIL = "GET_SALE_CREDIT_SINGLE_RECORD_FAIL";

export const GET_SALE_CREDIT_REQUEST = "GET_SALE_CREDIT_REQUEST";
export const GET_SALE_CREDIT_SUCCESS = "GET_SALE_CREDIT_SUCCESS";
export const GET_SALE_CREDIT_FAIL = "GET_SALE_CREDIT_FAIL";

export const GET_SALE_CREDIT_ON_SHOP_REQUEST = "GET_SALE_CREDIT_ON_SHOP_REQUEST";
export const GET_SALE_CREDIT_ON_SHOP_SUCCESS = "GET_SALE_CREDIT_ON_SHOP_SUCCESS";
export const GET_SALE_CREDIT_ON_SHOP_FAIL = "GET_SALE_CREDIT_ON_SHOP_FAIL";

export const UPDATE_SALE_CREDIT_REQUEST = "UPDATE_SALE_CREDIT_REQUEST";
export const UPDATE_SALE_CREDIT_SUCCESS = "UPDATE_SALE_CREDIT_SUCCESS";
export const UPDATE_SALE_CREDIT_FAIL = "UPDATE_SALE_CREDIT_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS"